import type React from "react";

export interface SkeletonProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Skeleton component for displaying loading placeholder animations.
 *
 * @example
 * // Basic skeleton
 * <Skeleton className="h-4 w-32" />
 *
 * @example
 * // With custom color (for dark theme panels)
 * <Skeleton className="bg-gray-700 h-10 w-full" />
 *
 * @example
 * // With children
 * <Skeleton className="h-20 w-20">
 *   <span className="text-xs">Loading...</span>
 * </Skeleton>
 */
export function Skeleton({ className = "", children }: SkeletonProps) {
  return <div className={`skeleton ${className}`}>{children}</div>;
}
